import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { CmsComponentTypeEnum } from '@models/enums';
import { Cta,Media,TextMediaBox } from '@interfaces/config';

import { TImageConfig } from '@interfaces/media';
export namespace WebinarDialog {
  export const TypeEnum = CmsComponentTypeEnum.WEBINAR_DIALOG;

  export interface ComponentConfig extends BaseComponentConfig {
    title: string;
    image: string,
    media:  TextMediaBox.MediaVideoConfig | TextMediaBox.MediaYoutubeVideoConfig | TextMediaBox.MediaAudioConfig;

    description:string;
    cta: Cta.ComponentConfig,
   
    imageConfig?: TImageConfig;
    
  }
}
//  